const Mainmenu = class extends HTMLElement {
	constructor() {
		super();
		this.header = document.querySelector(".shopify-section--header");
		this.openButtons = document.querySelectorAll('[role="open-button"]');
		this.closeButtons = this.querySelectorAll('[role="close-button"]');
		this.nav = this.querySelector('[role="nav"]');
		this.toggleButtons = document.querySelectorAll(
			'[role="main-menu-toggle-button"]'
		);
		this.overlay = this.querySelector('[role="overlay"]');
		this.rootItems = this.querySelectorAll('[role="root-item"]');
		this.linksWithSubmenu = this.querySelectorAll(".menu__item--link");
		this.submenuHandlers = this.querySelectorAll('[role="submenu-handler"]');
		this.submenusBackbuttons = this.querySelectorAll('[role="submenus-back"]');
		this.submenuBackbuttons = this.querySelectorAll('[role="submenu-back"]');
		this.isMobile = window.matchMedia("screen and (max-width: 768px)").matches;
	}

	connectedCallback() {
		this.init();
	}

	init() {
		this.addEventListener("mouseleave", this.closeMenu.bind(this));
		this.addEventListener("blur", this.closeMenu.bind(this));
		this.closeButtons.forEach((button) => {
			button.addEventListener("click", this.closeMenu.bind(this));
		});

		if (this.isMobile) {
			this.toggleButtons.forEach((button) => {
				button.addEventListener("click", this.toggleMenu.bind(this));
			});
		} else {
			this.toggleButtons.forEach((button) => {
				button.addEventListener("mouseover", this.openMenu.bind(this));
			});
		}

		this.openButtons.forEach((button) => {
			button.addEventListener("click", this.openMenu.bind(this));
		});

		this.rootItems.forEach((rootItem) => {
			if (this.isMobile && rootItem) {
				const svg = rootItem.querySelector(".menu__item--svg");
				svg?.addEventListener(
					"mouseover",
					this.handleRootItem.bind(this, rootItem)
				);
			} else {
				rootItem.addEventListener(
					"mouseover",
					this.handleRootItem.bind(this, rootItem)
				);
			}
		});

		this.submenuHandlers.forEach((submenuHandler) => {
			submenuHandler.addEventListener(
				"mouseover",
				this.handleSubmenu.bind(this, submenuHandler)
			);
		});

		// if (this.isMobile) {
		// 	this.linksWithSubmenu.forEach((link) => {
		// 		link.addEventListener("click", (e) => e.preventDefault());
		// 	});
		// }

		this.submenusBackbuttons.forEach((submenusBackbutton) => {
			submenusBackbutton.addEventListener(
				"click",
				this.submenusBack.bind(this)
			);
		});

		this.submenuBackbuttons.forEach((submenuBackbutton) => {
			submenuBackbutton.addEventListener("click", this.submenuBack.bind(this));
		});
	}

	toggleMenu(e) {
		this.toggleButtons.forEach((button) => {
			button.classList.toggle("open");
		});
		this.classList.toggle("open");

		if (this.classList.contains("open")) {
			this.openMenu();
		} else {
			this.closeMenu(e);
		}
	}

	openMenu() {
		this.header.classList.add("menu-open");
		this.classList.add("open");
		document.documentElement.style.setProperty(
			"--main-nav-height",
			this.nav.scrollHeight + "px"
		);
		this.focus();
		if (!this.isMobile) {
			this.rootItems[0].classList.add("active");
		}
	}

	closeMenu() {
		document.documentElement.style.setProperty("--main-nav-height", 0);
		this.classList.remove("open");
		setTimeout(() => {
			this.header.classList.remove("menu-open");
			this.removeActives();
		}, 300);
	}

	handleRootItem(rootItem) {
		this.rootItems.forEach((rootItem) => {
			rootItem.classList.remove("active");
		});
		rootItem.classList.add("active");
	}

	handleSubmenu(submenuHandler) {
		this.submenuHandlers.forEach((submenuHandler) => {
			submenuHandler.classList.remove("active");
		});
		submenuHandler.classList.add("active");
	}

	removeActives() {
		this.rootItems.forEach((rootItem) => {
			rootItem.classList.remove("active");
		});

		this.submenuHandlers.forEach((submenuHandler) => {
			submenuHandler.classList.remove("active");
		});
	}

	submenusBack() {
		this.rootItems.forEach((rootItem) => {
			rootItem.classList.remove("active");
		});
	}

	submenuBack() {
		this.submenuHandlers.forEach((submenuHandler) => {
			submenuHandler.classList.remove("active");
		});
	}
};

if (!window.customElements.get("main-menu")) {
	window.customElements.define("main-menu", Mainmenu);
}
